import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGaugeHigh, faUserGear } from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../contexts/auth";
import { useDispatch, useSelector } from "react-redux";
import { roleActions } from "../../redux/Role";
import { useLocation, useNavigate } from "react-router-dom";
import StatusContext from "../../contexts/status";
import { rolesCodes, getRoleLabel } from "../../constants/Roles";
import { FormUtility } from "../Utility/FormUtility";

function Header() {
  const location = useLocation();
  const navigation = useNavigate();
  const authContext = useContext(AuthContext);
  const statusContext = useContext(StatusContext);
  const dispatch = useDispatch();
  const userInfo = authContext.userInfo;
  const roles = useSelector((state) => state.role);
  const datiUtente = useSelector((state) => state.presaVisione);
  const [isOpen, setIsOpen] = useState(false);

  const utility = new FormUtility({ data: roles });

  useEffect(() => {
    if (!roles.authorities) {
      return;
    }

    switch (roles.authorities?.length) {
      case 1:
        dispatch(roleActions.setRoleSelected(roles.authorities[0]));
        break;
      case 0:
        dispatch(roleActions.setRoleSelected(rolesCodes.cittadino));
        break;
      default:
        if (
          (roles.authorities.includes(rolesCodes.comune) ||
            roles.authorities.includes(rolesCodes.comuneReferente)) &&
          roles.operatori.length === 0 &&
          roles.referenze.length === 0
        ) {
          dispatch(roleActions.setRoleSelected(rolesCodes.cittadino));
        }
        break;
    }
  }, [roles]);

  const logout = async () => {
    await authContext.logout();
  };

  const gobackManagement = () => {
    if (
      statusContext.checkEvent("onbeforeunload") &&
      !window.confirm("Le modifiche apportate potrebbero non essere salvate.")
    ) {
      return;
    }

    switch (location.pathname) {
      case "/gestione-librerie":
      case "/gestione-fasi":
      case "/gestione-avvisi":
        navigation("/home");
        return;
      case "/gestione-libreria":
        navigation("/gestione-librerie");
        return;
      case "/gestione-fase":
        navigation("/gestione-fasi");
        return;
      case "/gestione-avviso":
        navigation("/gestione-avvisi");
        return;
      case "/gestione-anagrafica-comune":
        navigation("/gestione-adesione-enti");
        return;
      case "/gestione-indirizzo-studio":
        navigation("/gestione-indirizzi-studio");
        return;

      default:
        if (location.pathname.startsWith("/anagrafica-referente/")) {
          navigation("/gestione-adesione-enti");
          return;
        }

        if (location.pathname.startsWith("/gestione-anagrafica-comune/")) {
          navigation("/gestione-adesione-enti");
          return;
        }

        if (location.pathname.startsWith("/gestione-librerie/")) {
          navigation("/gestione-comuni-librerie");
          return;
        }

        if (location.pathname.startsWith("/gestione-fase/")) {
          navigation("/gestione-fasi");
          return;
        }

        if (location.pathname.startsWith("/gestione-avviso/")) {
          navigation("/gestione-avvisi");
          return;
        }
        if (location.pathname.startsWith("/gestione-indirizzo-studio/")) {
          navigation("/gestione-indirizzi-studio");
          return;
        }

        const splitPath = location.pathname.split("/");
        if (location.pathname.startsWith("/gestione-operatori/")) {
          navigation("/gestione-anagrafica-operatori");
          return;
        }

        if (location.pathname.startsWith("/gestione-libreria/")) {
          navigation(
            "/gestione-librerie/" +
              splitPath[splitPath.length - (splitPath.length === 3 ? 1 : 2)]
          );
          return;
        }

        if (location.pathname.startsWith("/gestione-anagrafica-operatore")) {
          navigation("/gestione-operatori");
          return;
        }
        if (location.pathname.startsWith("/gestione-richiesta/") && roles.selected===rolesCodes.regione) {
            navigation("/gestione-domande");
            return;
          }


        if (location.pathname.startsWith("/gestione-richiesta/")) {
          navigation("/dashboard");
          return;
        }
        return;
    }
  };

  const checkNavigation = (path) => {
    if (
      statusContext.checkEvent("onbeforeunload") &&
      !window.confirm("Le modifiche apportate potrebbero non essere salvate.")
    ) {
      return;
    }
    setIsOpen(false);
    navigation(path);
  };

  const onNavigateSceltaRuolo = () => {
    if (
      statusContext.checkEvent("onbeforeunload") &&
      !window.confirm("Le modifiche apportate potrebbero non essere salvate.")
    ) {
      return;
    }

    authContext.removeRoleAndEnteSelected();
    dispatch(roleActions.setRoleSelected(null));
    navigation("/scelta-ruolo");
  };

  const getLabelEnte = (enteSelected) => {
    const muni = roles.operatori?.find((m) => m.id === parseInt(enteSelected));
    const refe = roles.referenze?.find((m) => m.id === parseInt(enteSelected));
    const comune = muni || refe;
    if (!comune) {
      return null;
    }

    let prefix = "";
    switch (comune.tipologia) {
      case "Comune":
        prefix = muni ? "Comune di " : "Comune di ";
        break;
      case "Unione di Comuni":
        break;
      case "Gestione Associata":
        prefix = "Gestione associata ";
        break;
      default:
        break;
    }
    return `${prefix}${comune.denominazione}`;
  };

  return (
    <div className="rtds-border-b rtds-border-gray-02 rtds-background-01 rtds-border-t">
      <div className=" rtds-container">
        <div className="rtds-flex rtds-justify-between rtds-items-center rtds-my-1 rtds-flex-wrap">
          <div className="rtds-flex rtds-items-center rtds-flex-wrap rtds-my-1 rtds-gap-2 ">
            {roles.selected && location.pathname === "/home" || location.pathname === "/dashboard" && (
              <div className=" rtds-inline-block rtds-whitespace-nowrap rtds-border-r rtds-border-gray-03 rtds-pr-2">
                <FontAwesomeIcon
                  icon={faGaugeHigh}
                  aria-hidden="true"
                  className="rtds-content-03"
                />{" "}
                <span>Cruscotto</span>
              </div>
            )}

            {
              roles.selected && 
              (!utility.checkRoles([rolesCodes.cittadino]) || !!datiUtente.datiUtente) &&
              location.pathname !== '/home' &&
              location.pathname !== '/scelta-ruolo' &&
              location.pathname !== '/dashboard' &&
              location.pathname !== "/presa-visione" && (
                <>
                  {
                    <button
                      type="button"
                      onClick={() => {
                        checkNavigation("/home");
                      }}
                      className="rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary rtds-btn--s "
                    >
                      <svg
                        className="rtds-icon rtds-fill-current rtds-transition-all group-hover/button:-rtds-translate-x-1 rtds-w-5 rtds-h-5 "
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--chevron-double-left`}
                        />
                      </svg>
                      Torna al Cruscotto
                    </button>
                  }

                  {
                    location.pathname !== "/gestione-istruttorie" &&
                    location.pathname !== "/dati-utente" &&
                    location.pathname !== "/gestione-avvisi" &&
                    location.pathname !== "/gestione-fasi" &&
                    location.pathname !== "/gestione-adesione-enti" &&
                    location.pathname !== "/gestione-indirizzi-studio" &&
                    location.pathname !== "/gestione-domande" &&
                    location.pathname !== "/gestione-errori" &&
                    location.pathname !== "/gestione-eventi" &&
                    location.pathname !== "/gestione-pagamenti" &&
                    location.pathname !== "/rettifica-iban" &&
                    !location.pathname.startsWith("/rettifica-ripresentazione") &&
                    !location.pathname.startsWith("/aggiornamento-isee") &&
                    (!location.pathname.startsWith("/gestione-richiesta") || roles.selected===rolesCodes.regione) &&
                    (!location.pathname.startsWith("/gestione-riapertura-richiesta") || roles.selected===rolesCodes.regione) &&
                    !location.pathname.startsWith("/gestione-operatori") &&
                    !location.pathname.startsWith("/secondo-accesso") && 
                    !location.pathname.startsWith("/terzo-accesso") && 
                    location.pathname !== "/gestione-email" &&
                    location.pathname !== "/gestione-pagamenti" && (
                      <button
                        type="button"
                        onClick={() => gobackManagement()}
                        className="rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary rtds-btn--s"
                      >
                        <svg
                          className="rtds-icon rtds-fill-current rtds-transition-all group-hover/button:-rtds-translate-x-1 rtds-w-5 rtds-h-5"
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                        >
                          <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--chevron-left`}
                          />
                        </svg>
                        Indietro
                      </button>
                    )}
                </>
              )}
            {roles.selected &&
              !(
                (roles.authorities?.length === 1 ||
                  roles.authorities?.length === 0) &&
                (!roles.selected || roles.selected === rolesCodes.cittadino)
              ) && (
                <div>
                  <button
                    type="button"
                    className="rtds-btn rtds-btn--icon rtds-btn--primary rtds-mr-1"
                    title={
                      "Vai alla pagina 'Ruolo' per selezionare la modalità di accesso all'applicazione"
                    }
                    onClick={() => onNavigateSceltaRuolo()}
                    hidden={
                      location.pathname === "/scelta-ruolo" ||
                      roles.authorities?.length === 1
                    }
                  >
                    <FontAwesomeIcon icon={faUserGear} aria-hidden="true" />{" "}
                    <span className="rtds-sr-only">Seleziona Ruolo</span>
                  </button>
                  <h2 className="rtds-text-lg md:rtds-text-2xl rtds-content-primary rtds-inline ">
                    {roles.enteSelected
                      ? getLabelEnte(roles.enteSelected)
                      : getRoleLabel(roles.selected)}
                  </h2>
                </div>
              )}
          </div>

          <div className="rtds-flex rtds-items-center">
            {/*<span className="rtds-hidden lg:rtds-inline-block">
              Benvenuto/a
            </span>*/}

            <div className="rtds-dropdown-menu rtds-relative">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="rtds-btn rtds-btn--only-text rtds-px-1  rtds-group"
                aria-expanded={isOpen} // Cambia dinamicamente tra true e false
                aria-controls="submenumenu"
              >
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 rtds-transition-all rtds-duration-200 rtds-ease-out rtds-transform group-hover:rtds-translate-x-1"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--user-circle`}
                  />
                </svg>

                <span>
                  {userInfo
                    ? userInfo.extras.name + " " + userInfo.extras.familyName
                    : ""}
                </span>

                <svg
                  className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-ml-auto rtds-transition-all rtds-dropdown-menu__trigger-icon group-aria-expanded:-rtds-rotate-180"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-down`}
                  />
                </svg>
              </button>

              {isOpen && (
                <ul
                  className="rtds-px-2 rtds-absolute rtds-border rtds-rounded rtds-border-gray-02 rtds-background-01 rtds-gap-2"
                  id="submenumenu"
                >
                  {
                  roles.selected === rolesCodes.cittadino &&
                  location.pathname !== "/presa-visione" && 
                  location.pathname !== "/dati-utente" && (
                  <li className="rtds-mb-2">
                    <button
                      className="rtds-btn--s rtds-btn rtds-btn--outlined"
                      onClick={() => checkNavigation('/dati-utente')}
                    >
                      I Miei Dati
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 rtds-transition-all rtds-duration-200 rtds-ease-out rtds-transform group-hover:rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                        />
                      </svg>
                    </button>
                  </li>
                  )}
                  <li className="rtds-mb-2">
                    <a
                      className="rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--outline rtds-btn--s"
                      onClick={() => logout()}
                      aria-label="Esci"
                      href="#"
                    >
                      Esci
                      <svg
                        className="rtds-icon rtds-fill-current group-hover/button:rtds-translate-x-1 rtds-w-5 rtds-h-5"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--arrow-right-start-on-rectangle`}
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              )}
            </div>

            {/* <ul
              className="rtds-px-2 rtds-absolute rtds-border rtds-rounded rtds-border-gray-02 rtds-background-01 rtds-gap-2"
              style={{ right: "0" }}
            >
              <li>
                <a
                  className="rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--outline rtds-btn--s"
                  onClick={() => logout()}
                  aria-label="Esci"
                  href="#"
                >
                  Esci
                  <svg
                    className="rtds-icon rtds-fill-current group-hover/button:rtds-translate-x-1 rtds-w-5 rtds-h-5"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--arrow-right-start-on-rectangle`}
                    />
                  </svg>
                </a>
              </li>
            </ul>
            */}

            {/*<div className='rtds-mr-2 rtds-inline-block '>
              <span className='rtds-hidden lg:rtds-inline-block'>
                Benvenuto/a&nbsp;{' '}
              </span>
              <span>
                {userInfo
                  ? userInfo.extras.name + ' ' + userInfo.extras.familyName
                  : ''}
              </span>
            </div> */}

            {/*  <a
              className='rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--outline rtds-btn--s'
              onClick={() => logout()}
              aria-label='Esci'
              href='#'
            >
              Esci
              <svg
                className='rtds-icon rtds-fill-current group-hover/button:rtds-translate-x-1 rtds-w-5 rtds-h-5'
                aria-hidden='true'
                focusable='false'
                role='img'
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--arrow-right-start-on-rectangle`}
                />
              </svg>
            </a>


            */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
